/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from 'ng2-translate/src/translate.pipe';
import * as i2 from 'ng2-translate/src/translate.service';
import * as i3 from '@angular/common';
import * as i4 from '../../../../../app/components/widgets/panel/panel.component';
import * as i5 from '@angular/router';
const styles_PanelWidget:any[] = ([] as any[]);
export const RenderType_PanelWidget:i0.RendererType2 = i0.ɵcrt({encapsulation:2,styles:styles_PanelWidget,
    data:{}});
function View_PanelWidget_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),6,'span',[['class',
      'hidden-xs'],['style','cursor: pointer']],(null as any),[[(null as any),'click']],
      (_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.back()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i0.ɵeld(1,0,(null as any),(null as any),
      0,'i',[['class','fa fa-angle-left']],(null as any),(null as any),(null as any),
      (null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),['\n      '])),
      (_l()(),i0.ɵeld(3,0,(null as any),(null as any),2,'span',[['style','padding-bottom: 1px; border-bottom: 1px dotted white']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(4,(null as any),['',''])),i0.ɵpid(131072,i1.TranslatePipe,[i2.TranslateService,
          i0.ChangeDetectorRef]),(_l()(),i0.ɵted(-1,(null as any),[' ']))],(null as any),
      (_ck,_v) => {
        const currVal_0:any = i0.ɵunv(_v,4,0,i0.ɵnov(_v,5).transform('Go Back'));
        _ck(_v,4,0,currVal_0);
      });
}
export function View_PanelWidget_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),16,'div',[['class',
      'panel panel-default']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i0.ɵted(-1,(null as any),['\n    '])),(_l()(),i0.ɵeld(2,
      0,(null as any),(null as any),8,'div',[['class','panel-heading'],['style','display: flex;justify-content: space-between']],
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i0.ɵted(-1,(null as any),['\n    '])),(_l()(),i0.ɵand(16777216,(null as any),
      (null as any),1,(null as any),View_PanelWidget_1)),i0.ɵdid(5,16384,(null as any),
      0,i3.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i0.ɵted(-1,(null as any),['\n        '])),(_l()(),i0.ɵeld(7,0,(null as any),
          (null as any),2,'span',([] as any[]),[[8,'className',0]],(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵeld(8,0,(null as any),(null as any),
          0,'i',([] as any[]),[[8,'className',0]],(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵted(9,(null as any),[' ',''])),(_l()(),i0.ɵted(-1,
          (null as any),['\n    '])),(_l()(),i0.ɵted(-1,(null as any),['\n    '])),
      (_l()(),i0.ɵeld(12,0,(null as any),(null as any),3,'div',[['class','panel-body']],
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(-1,(null as any),['\n        '])),i0.ɵncd((null as any),0),(_l()(),
          i0.ɵted(-1,(null as any),['\n    '])),(_l()(),i0.ɵted(-1,(null as any),['\n']))],
      (_ck,_v) => {
        var _co:i4.PanelWidget = _v.component;
        const currVal_0:any = _co.showGoBack;
        _ck(_v,5,0,currVal_0);
      },(_ck,_v) => {
        var _co:i4.PanelWidget = _v.component;
        const currVal_1:any = i0.ɵinlineInterpolate(1,'',(_co.showGoBack? 'pull-right': ''),
            '');
        _ck(_v,7,0,currVal_1);
        const currVal_2:any = i0.ɵinlineInterpolate(1,'fa ',_co.icon,'');
        _ck(_v,8,0,currVal_2);
        const currVal_3:any = _co.title;
        _ck(_v,9,0,currVal_3);
      });
}
export function View_PanelWidget_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'panel',([] as any[]),
      (null as any),(null as any),(null as any),View_PanelWidget_0,RenderType_PanelWidget)),
      i0.ɵdid(1,49152,(null as any),0,i4.PanelWidget,[i3.Location,i5.Router],(null as any),
          (null as any))],(null as any),(null as any));
}
export const PanelWidgetNgFactory:i0.ComponentFactory<i4.PanelWidget> = i0.ɵccf('panel',
    i4.PanelWidget,View_PanelWidget_Host_0,{title:'title',icon:'icon',showGoBack:'showGoBack',
        goBackLink:'goBackLink'},{},['*']);
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Vzci9zcmMvYXBwL3NyYy9hcHAvY29tcG9uZW50cy93aWRnZXRzL3BhbmVsL3BhbmVsLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy91c3Ivc3JjL2FwcC9zcmMvYXBwL2NvbXBvbmVudHMvd2lkZ2V0cy9wYW5lbC9wYW5lbC5jb21wb25lbnQudHMiLCJuZzovLy91c3Ivc3JjL2FwcC9zcmMvYXBwL2NvbXBvbmVudHMvd2lkZ2V0cy9wYW5lbC9wYW5lbC5jb21wb25lbnQuaHRtbCIsIm5nOi8vL3Vzci9zcmMvYXBwL3NyYy9hcHAvY29tcG9uZW50cy93aWRnZXRzL3BhbmVsL3BhbmVsLmNvbXBvbmVudC50cy5QYW5lbFdpZGdldF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIjxkaXYgY2xhc3M9XCJwYW5lbCBwYW5lbC1kZWZhdWx0XCI+XG4gICAgPGRpdiBjbGFzcz1cInBhbmVsLWhlYWRpbmdcIiBzdHlsZT1cImRpc3BsYXk6IGZsZXg7anVzdGlmeS1jb250ZW50OiBzcGFjZS1iZXR3ZWVuXCI+XG4gICAgPHNwYW4gKGNsaWNrKT1cImJhY2soKVwiIHN0eWxlPVwiY3Vyc29yOiBwb2ludGVyXCIgY2xhc3M9XCJoaWRkZW4teHNcIiAqbmdJZj1cInNob3dHb0JhY2tcIj48aSBjbGFzcz1cImZhIGZhLWFuZ2xlLWxlZnRcIj48L2k+XG4gICAgICA8c3BhbiBzdHlsZT1cInBhZGRpbmctYm90dG9tOiAxcHg7IGJvcmRlci1ib3R0b206IDFweCBkb3R0ZWQgd2hpdGVcIj57eydHbyBCYWNrJyB8IHRyYW5zbGF0ZX19PC9zcGFuPiA8L3NwYW4+XG4gICAgICAgIDxzcGFuIGNsYXNzPVwie3tzaG93R29CYWNrID8gJ3B1bGwtcmlnaHQnIDogJyd9fVwiPjxpIGNsYXNzPVwiZmEge3tpY29ufX1cIj48L2k+IHt7dGl0bGV9fTwvc3Bhbj5cbiAgICA8L2Rpdj5cbiAgICA8ZGl2IGNsYXNzPVwicGFuZWwtYm9keVwiPlxuICAgICAgICA8bmctY29udGVudD48L25nLWNvbnRlbnQ+XG4gICAgPC9kaXY+XG48L2Rpdj4iLCI8cGFuZWw+PC9wYW5lbD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7b0JDRUk7TUFBQTtNQUFBO1FBQUE7UUFBQTtRQUFNO1VBQUE7VUFBQTtRQUFBO1FBQU47TUFBQSxnQ0FBb0Y7TUFBQTtNQUFBLDhCQUFnQztNQUNsSDtVQUFBO01BQW1FOzhCQUFBLEdBQWdDOztRQUFoQztRQUFBOzs7O29CQUh6RTtNQUFBO01BQUEsZ0JBQWlDLDhDQUM3QjtNQUFBO01BQUEsd0VBQWdGO2FBQUEsK0JBQ2hGO01BQUEsMERBQUE7TUFBQTtNQUM2RyxrREFDekc7VUFBQTtVQUFBLDhCQUFpRDtVQUFBO1VBQUEsZ0JBQTJCLDJDQUFpQjtVQUFBLDJCQUMzRjtNQUNOO1VBQUE7TUFBd0IseURBQ3BCLGtCQUF5QjtpQkFBQSwrQkFDdkI7OztRQU4yRDtRQUFqRSxXQUFpRSxTQUFqRTs7O1FBRVU7WUFBQTtRQUFOLFdBQU0sU0FBTjtRQUFvRDtRQUFILFdBQUcsU0FBSDtRQUEyQjtRQUFBOzs7O29CQ0pwRjtNQUFBO2FBQUE7VUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/widgets/panel/panel.component.ngfactory.ts